<div class="pagination" *ngIf="maxPage > 1">
    <ul>
        <li *ngIf="(pagination.page > 0)">
            <a (click)="setPage(pagination.page-1)">
                <i class="fa fa-angle-left"></i>
            </a>
        </li>
        <li *ngFor="let pageIdx of pageIdxs">
            <a (click)="setPage(pageIdx)" *ngIf="pagination.page != pageIdx">{{pageIdx + 1}}</a>
            <span *ngIf="pagination.page == pageIdx" class="active">{{pageIdx + 1}}</span>
        </li>
        <li *ngIf="pagination.page < maxPage-1">
            <a (click)="addPage(pagination.page)">
                <i class="fa fa-angle-right"></i>
            </a>
        </li>
    </ul>
</div>